import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { STRIPE_ASSETS, STRIPE_DISCLOSURE_TEXT } from '../../../v2-layout/stripe-treasury/stripe-treasury.constants';

export interface BankAccountKycDialogResult {
    startVerification: boolean;
}

/**
 * Why the KYC intro is being shown. The checklist, the Stripe note and the buttons are the same for every
 * reason; only the heading and the opening paragraph change.
 */
export enum KycDialogVariant {
    /** Connecting a bank account — the original entry. */
    BANK_ACCOUNT = 'bank_account',
    /** SD-10158: the "Online payments are off" banner's Verify now. */
    ONLINE_PAYMENTS = 'online_payments',
    /** SD-10316: the Financial Accounts setup page's "Set up Treasury Balance". */
    TREASURY = 'treasury',
}

const KYC_EXPLANATION = 'Stripe needs to confirm who we\'re moving money for, a one-time check called Know Your Customer (KYC) verification.';

export const KYC_DIALOG_COPY: Record<KycDialogVariant, { title: string; intro: string }> = {
    [KycDialogVariant.BANK_ACCOUNT]: {
        title: 'First, let\'s verify your association',
        intro: 'Before a bank account can be connected, federal rules require us to confirm who we\'re moving money for. Our payments partner Stripe runs this one-time check, called Know Your Customer (KYC) verification.',
    },
    [KycDialogVariant.ONLINE_PAYMENTS]: {
        title: 'Verify your association to accept payments online',
        intro: `For homeowners to pay invoices online and for funds to reach your bank, ${KYC_EXPLANATION}`,
    },
    [KycDialogVariant.TREASURY]: {
        title: 'Verify your association to open Treasury Balance',
        intro: `Before Treasury Balance can hold funds, pay vendors and issue spend cards, ${KYC_EXPLANATION}`,
    },
};

@Component({
    selector: 'app-bank-account-kyc-dialog',
    standalone: true,
    templateUrl: './bank-account-kyc-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BankAccountKycDialogComponent {
    @Input() open = false;
    @Input() variant: KycDialogVariant = KycDialogVariant.BANK_ACCOUNT;
    @Output() readonly closed = new EventEmitter<BankAccountKycDialogResult>();

    readonly stripeWordmark = STRIPE_ASSETS.WORDMARK;
    readonly disclosureText = STRIPE_DISCLOSURE_TEXT.PARTNER_DISCLOSURE;

    get copy(): { title: string; intro: string } {
        return KYC_DIALOG_COPY[this.variant] ?? KYC_DIALOG_COPY[KycDialogVariant.BANK_ACCOUNT];
    }
}
